import { AppSku } from '@polaris-customerweb/sharedcomponents.core';
import { cloneDeep } from 'lodash-es';

import { CommunityPolicyDto } from 'src/app/dtos/community-policy.dto';

export class CommunityPolicy {
    private rawCommunityPolicy: CommunityPolicyDto;

    constructor(rawCommunityItem: CommunityPolicyDto) {
        this.rawCommunityPolicy = cloneDeep(rawCommunityItem);
    }

    get appSku(): AppSku {
        return this.rawCommunityPolicy.appSku || 'ORV';
    }

    get version(): string {
        return this.rawCommunityPolicy.version;
    }

    get text(): string {
        return this.rawCommunityPolicy.text;
    }
}
